import { createAsyncThunk } from '@reduxjs/toolkit';
import { logger } from 'common/services';
import { selectMyCommunityId } from 'community/api';
import { RootState } from 'store';
import { tagServiceApi } from 'tags/tagServiceApi';

import { EventWizardFormSerializedValues } from '../../validation';

export const updateTagCategories = createAsyncThunk<
  void,
  { eventIds: number[]; values: EventWizardFormSerializedValues }
>('[Event Wizard] Update Tag Categories', async ({ eventIds, values }, { dispatch, getState }) => {
  const tagCategories = values.tagCategories ?? [];
  const categories = tagCategories.map(({ name, tags }) => ({ name, tags, isSingleSelection: true }));

  // Tags are scoped to a community and an event, and the Tag API authorises the
  // write against the community in the path. The wizard creates events in the
  // host's own community — the same selector createEvent and updateEvent use.
  const communityId = selectMyCommunityId(getState() as RootState);
  if (!communityId) {
    logger.error('Cannot save tag categories without a community', { eventIds });
    return;
  }

  await Promise.all(
    eventIds.map(async (eventId) => {
      try {
        await dispatch(
          tagServiceApi.endpoints.setEventTagCategories.initiate({ communityId, eventId, categories })
        ).unwrap();
      } catch (error) {
        logger.error('Failed to save tag categories for event', { eventId, error });
      }
    })
  );
});
